import React from "react";
import image1 from "../../assets/job1.png";
import image2 from "../../assets/job2.png";
import light from "../../assets/VectorlightHome.png";
import heart from "../../assets/VectorheartHome.png";
import { motion } from "framer-motion";

export const CarrersSection: React.FC = () => {
  return (
    <section className="w-full h-full flex flex-col justify-center items-center bg-black px-4 sm:px-8 md:px-12 lg:px-20 text-white py-8">
      <div className="max-w-7xl mx-auto">
        <h1 className="text-center font-bold uppercase tracking-tight text-xl sm:text-2xl md:text-3xl mb-10 md:mb-14">
          ¿POR QUÉ UNIRTE A NOSOTROS?
        </h1>

        {/* Bloque 1: imagen izquierda, texto derecha, animation from left to right */}
        <motion.div
          initial={{ opacity: 0, x: -40 }}
          whileInView={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.5 }}
          viewport={{ once: true }}
          className="grid grid-cols-1 md:grid-cols-2 gap-8 md:gap-16 lg:gap-24 items-center mb-12 md:mb-16"
        >
          <div>
            <img
              draggable={false}
              src={image1}
              alt="Equipo"
              className="w-full"
            />
          </div>

          <div className="text-left max-w-md md:max-w-lg lg:max-w-xl">
            <div className="flex-col space-y-2">
              <img
                draggable={false}
                src={light}
                width={15}
                height={15}
                alt="Icon"
                className="w-6 h-6 mb-4"
              />
              <h2 className="text-xl sm:text-lg font-semibold">
                Sobre Grupo Peña Defilló
              </h2>
            </div>
            <p className="text-sm font-inter leading-relaxed text-white/90 mt-2">
              Grupo Peña Defilló es el grupo de comunicaciones más grande de
              República Dominicana. Conocido por liderar y aportar a grandes
              cambios en la industria publicitaria local y de la región del
              Caribe, con años de experiencia en contenido, media y digital.
            </p>
          </div>
        </motion.div>

        {/* Bloque 2: texto izquierda, imagen derecha, animation from right to left */}
        <motion.div
          initial={{ opacity: 0, x: 40 }}
          whileInView={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.5 }}
          viewport={{ once: true }}
          className="grid grid-cols-1 md:grid-cols-2 gap-8 md:gap-16 lg:gap-24 items-center"
        >
          <div className="order-2 md:order-none text-left max-w-md md:max-w-lg lg:max-w-xl">
            <div className="flex-col space-y-2">
              <img
                draggable={false}
                src={heart}
                width={15}
                height={15}
                alt="Icon"
                className="w-6 h-6 mb-4"
              />
              <h2 className="text-xl sm:text-lg font-semibold">
                Nuestro propósito
              </h2>
            </div>
            <p className="text-sm font-inter leading-relaxed text-white/90 mt-2">
              Creamos conexiones innovadoras para impactar de manera
              significativa la vida de las personas, a través de soluciones de
              comunicación que dan valor a las marcas.
            </p>
          </div>
          <div className="flex justify-center">
            <img
              draggable={false}
              src={image2}
              alt="Cultura"
              className="w-full"
            />
          </div>
        </motion.div>
      </div>
    </section>
  );
};
